import axios from 'axios'

export default {
  state: {
    distribution_list: null,
  },
  getters: {
    getDistributionList: (s) => s.distribution_list,
  },
  mutations: {
    setDistributionList: (s, list) =>
      (s.distribution_list = list.filter((el) => el.translates.length)),
  },
  actions: {
    fetchDistributionList(ctx, lang = 'ru') {
      // if (lang === 'be') lang = 'ru';
      return axios({
        method: 'GET',
        url: `api/v3/distribution/items/?language=${lang}`,
      })
        .then((response) => {
          const list = response.data.results
          ctx.commit('setDistributionList', list)
        })
        .catch((error) => {
          console.error(error)
        })
    },
    DistributionSetVideoProgress(ctx, { id, progress }) {
      const fd = new FormData()
      fd.append('progress', progress)
      return axios({
        method: 'POST',
        data: fd,
        url: `/api/v3/distribution/items/${id}/progress/`,
      }).catch((error) => {
        console.error(error)
      })
    },
    DistributionSetLike(ctx, id) {
      return axios({
        method: 'POST',
        url: `/api/v3/distribution/items/${id}/like/`,
      }).catch((error) => {
        console.error(error)
      })
    },
    DistributionSetView(ctx, id) {
      return axios({
        method: 'POST',
        url: `/api/v3/distribution/items/${id}/view/`,
      }).catch((error) => {
        console.error(error)
      })
    },
    DistributionSetFavorite(ctx, id) {
      return axios({
        method: 'POST',
        url: `/api/v3/distribution/items/${id}/favorite/`,
      }).catch((error) => {
        console.error(error)
      })
    },
  },
}
